import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'

import StatsCard from '../StatsCard/Index'

const StatsChartDataCard = ({ title, subtitle, color, icon, chartData, value, fetching }) => {
  const userTimeZoneAbbr = useSelector(sessionUserSelector.timezoneAbbr)

  return (
    <StatsCard
      fetching={fetching}
      title={title}
      subtitle={subtitle}
      color={color}
      icon={icon}
      value={value}
      chartData={chartData || null}
      chartTimeZoneAbbr={userTimeZoneAbbr}
    />
  )
}

StatsChartDataCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  chartData: PropTypes.object,
  value: PropTypes.number,
  fetching: PropTypes.bool,
}

export default StatsChartDataCard
